import { render, staticRenderFns } from "./ProjectNavBar.vue?vue&type=template&id=ea8671aa&scoped=true"
import script from "./ProjectNavBar.vue?vue&type=script&lang=js"
export * from "./ProjectNavBar.vue?vue&type=script&lang=js"
import style0 from "./ProjectNavBar.vue?vue&type=style&index=0&id=ea8671aa&lang=scss&scoped=true"
import style1 from "./ProjectNavBar.vue?vue&type=style&index=1&id=ea8671aa&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea8671aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea8671aa')) {
      api.createRecord('ea8671aa', component.options)
    } else {
      api.reload('ea8671aa', component.options)
    }
    module.hot.accept("./ProjectNavBar.vue?vue&type=template&id=ea8671aa&scoped=true", function () {
      api.rerender('ea8671aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/layout/ProjectNavBar.vue"
export default component.exports